import React from 'react';
import { Row, Col } from 'react-bootstrap';
import MenuCard from './MenuCard';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import './menu.scss';

class Menu extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let [breakfast, lunch, dinner] = ['breakfast', 'lunch', 'dinner'].map((type, index) => {

      const menuCardData = this.props.menu.apiData[type];
      if(!menuCardData) return null;

      return (
        <Col sm={4}>
          <MenuCard type={type} {...menuCardData}/>
        </Col>
      );
    });

    /* If no menu provided then render empty section */
    return (
      <Row className="restaurants-menu-component">
        <Col xs={12}>
        {
          !breakfast && !lunch && !dinner
           ? <h1 className="text-center"><i className="fa fa-ellipsis-h fa-fw"/></h1>
           : (
            <div>
              <h3><strong>{this.props.translate('restaurants.menu.title')}</strong></h3>
              <p>{this.props.menu.apiData.extra}</p>
              <br/>

              {breakfast}
              {lunch}
              {dinner}
            </div>
           )
        }
        </Col>
      </Row>
    );
  }
}

Menu.displayName = 'PagesRestaurantsMenu';
Menu.propTypes = {};
Menu.defaultProps = {};

const mapStateToProps = (state) => {
  return {
      translate: getTranslate(state.locale),
      hotel: state.hotel,
      menu: state.menu
  }
};

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./components/pages/restaurants/Menu.js